import { CommonModule } from "@angular/common";
import { Component, NO_ERRORS_SCHEMA, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { TagInputModule } from 'ngx-chips';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { JobService } from 'src/app/services/job.service';
import { PageType } from "src/app/services/pageTypes";
import { NodataFoundComponent } from 'src/app/widget/nodata-found/nodata-found.component';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';
import Swal from "sweetalert2";
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { PlanCardComponent } from '../../bussinesspages/user-management/plan-card/plan-card.component';
import { ApiService } from "./../../../services/api.service";
import { AppSettings } from "./../../../services/AppSettings";
import { UtilService } from "./../../../services/util.service";
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


export interface EmailClassObject {
  status: string;
  class: string;
}

@Component({
  selector: "app-referrals",
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule, NgbModule, PlanCardComponent, CommonSkeletonComponent,
InfiniteScrollModule, TagInputModule, NodataFoundComponent, TimezoneDatePipe,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: "./referrals.component.html",
  styleUrls: ["./referrals.component.scss"],
})
export class ReferralsComponent implements OnInit {
  id = "1";
  connectionRequest: UntypedFormGroup;
  bsModalRef: BsModalRef;
  splitPattern = new RegExp("[,;:]");
  validators = [this.emailValid];
  accdianId;
  userRes;
  faqresponse;
  inviteRes: { userInvites: any[] } = { userInvites: [] };
  appliedFilter: string = 'All';
  allUserInvites: any[] = [];
  arr;
  stopScroll: boolean = false;
  loadAPIcall: boolean = true;
  inviteListLoading : boolean = true;
  searchSubject = new Subject<string>();
  existLength;
  searchForm: UntypedFormGroup;
  existOrInvited: Array<any> = [];
  selectedFilterName: string = "All";
  prevAfterkey: any = null;
  userId = localStorage.getItem('userId');
  url = AppSettings.photoUrl;
  gigsumoConstants = GigsumoConstants
  public errorMessages = {
    emailValid: "Please enter valid email id",
  };
  showText: string;
  existUser: any[] = [];
  inviteUser: any[] = [];
  duplicateEmails: any[] = [];
  inactiveUsers: any[] = [];
  invitesdata: any; // Added property to fix compile error
  activeAccordionIndex: number | null = 0; // Track active accordion item
  constructor(
    private fb: UntypedFormBuilder,
    private pageType: PageType,
    private modalService: BsModalService,
    private api: ApiService,
    private util: UtilService,
    private router: Router,
    private JobServicecolor: JobService,

  ) { }

  ngOnInit() {
    this.connectionRequest = this.fb.group({
      email: [null, Validators.required],
      msg: [null],
    });
    this.userAPI();
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    )
      .subscribe(
        res => {
          this.util.startLoader();
          this.onSearch();
        }
      )
    this.getinviteData();
  }


  getinviteData() {
    this.loadAPIcall1 = true
    const data: any = { "screenType": this.gigsumoConstants.IN_APP, "userId": localStorage.getItem('userId') };
    this.api.create("home/getReferralCountsAndPoints", data).subscribe((res) => {
      // this.api.query("home/getReferralCountsAndPoints/" + localStorage.getItem('userId')).subscribe((res) => {
      this.loadAPIcall = false
      this.util.stopLoader();
      if (res.code == "00000") {
        if (res) {
          this.loadAPIcall1 = false;
          this.invitesdata = res;
          this.allocationCards[0].value = this.invitesdata.data.totalCount;
          this.allocationCards[1].value = this.invitesdata.data.acceptedCount;
          this.allocationCards[2].value = this.invitesdata.data.pendingCount;
          this.allocationCards[3].value = this.invitesdata.data.cancelledCount;
          this.allocationCards[4].value = this.invitesdata.data.totalReferralPoints

        }
      } else {
        this.util.stopLoader();
        this.loadAPIcall1 = false;
      }
    }, err => {
      this.loadAPIcall1 = false;
      this.util.stopLoader();
    })
  }

  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }
  keyupdata(value: string) {
    if(value == '' || value.trim() != ''){
      this.searchSubject.next(value.trim());
    }    
  }
  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }
  userAPI() {
    // this.util.startLoader();
    this.loadAPIcall = true
    this.api.query("user/" + this.userId).subscribe(
      (res) => {
        this.loadAPIcall = false
        this.util.stopLoader();
        if (res && res.code === "00000") {
          this.userRes = res;
        }
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }
  activeTab(getid) {
    this.selectedFilterName = "All";
    this.params.searchContent = null;
    this.searchContent = "";
    this.params.searchAfterKey = null;
    this.params.status = "All";
    this.stopScroll = false
    this.prevAfterkey = null;
    this.inviteRes = { userInvites: [] };
    this.connectionRequest.controls['email'].setErrors(null);
    let data: any = {};
    this.id = getid;
    if (getid == "2") {
      this.getinviteData();
      this.inviteduserList();
    }
    if (getid == "1") {
      data.ComponentName = "InvitesCerditsComponent";
      data.show = true;
      //this.pageType.setsuggjob(data);
    }
    if (getid == "3") {
      data.ComponentName = "InvitesCerditsComponent";
      data.show = false;
      // this.pageType.setsuggjob(data);
      this.FAQList();

    }
  }

  toggleAccordion(index: number) {
    // Toggle accordion: close if already open, open if closed
    this.activeAccordionIndex = this.activeAccordionIndex === index ? null : index;
  }

  accadian(id) {
    this.accdianId = id;
  }
  sendMessage(userId: string) {
    var userData: any = {};
    userData.groupId = userId;
    userData.type = "USER";
    this.router.navigate(["message"], { queryParams: userData });
  }

  Connect(userId) {
    let data: any = {};
    data.userId = userId;
    data.requestedBy = this.userId;
    this.util.startLoader();
    this.api.create("user/connect", data).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == "00000") {
        Swal.fire({
          icon: "success",
          title: "Request sent successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      const invites = this.inviteRes.userInvites.filter(
        (invite) => invite.inviteeUser?.userId === userId
      );
      if (invites.length > 0) {
        invites.forEach((invite) => {
          invite.inviteeUser.connectionStatus = "REQUEST_SENT";
          invite.status = "COMPLETED";
        });
      }

    });
  }

  cancel(userId) {
    let data: any = {};
    data.userId = userId;
    this.util.startLoader();
    this.api.create("user/connect/cancel", data).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == "00000") {
        Swal.fire({
          icon: "success",
          title: "Request cencel successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        });
        const invites = this.inviteRes.userInvites.filter(
          (invite) => invite.inviteeUser?.userId === userId
        );

        if (invites.length > 0) {
          invites.forEach((invite) => {
            invite.inviteeUser.connectionStatus = "NOT_CONNECTED";
            invite.status = "COMPLETED";
          });
        }

      }
    });
  }

  FAQList() {
    let data: any = {};
    data.module = "Referral";
    this.loadAPIcall = true
    this.api.create("home/findFAQs", data).subscribe(
      (res) => {
        this.loadAPIcall = false
        this.util.stopLoader();
        if (res.code == "00000") {
          this.faqresponse = res.data;
        }
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }
  @ViewChild("exist") popup: any;
  params = {
    limit: 10,
    page: 0,
    searchAfterKey: null,
    searchContent: null,
    userId: this.userId,
    status: 'All',
    screenType: "in-app"

  };
  inviteduserList() {
    this.findUserInvitesApiCAll(this.params)
  }

  allocationCards = [
    {
      name: "Total Invites",
      value: null
    },
    {
      name: "Invites Accepted",
      value: null
    },
    {
      name: "Pending Acceptance",
      value: null
    },
    {
      name: "Invites Cancelled",
      value: null
    },
    {
      name: "Referral Credits",
      value: null
    }
  ];

  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    // scroll
  };

  // closemodel() {
  //   this.connectionRequest.value.email;
  //   this.connectionRequest.value.email = this.connectionRequest.value.email.filter((val) =>
  //     this.existUser && Array.isArray(this.existUser) && !this.existUser.includes(val)
  //   );
  //   this.connectionRequest.value.email = this.connectionRequest.value.email.filter((val) =>
  //     this.inviteUser && Array.isArray(this.inviteUser) && !this.inviteUser.includes(val)
  //   );
  //   this.connectionRequest.value.email = this.connectionRequest.value.email.filter((val) =>
  //     this.duplicateEmails && Array.isArray(this.duplicateEmails) && !this.duplicateEmails.includes(val)
  //   );
  //   let value = this.connectionRequest.value.email;
  //   this.connectionRequest.reset();
  //   this.connectionRequest.patchValue({ email: value });
  //   this.modalService.hide(1);
  // }
  closemodel() {
    let emailList = this.connectionRequest.value.email;

    if (Array.isArray(this.existUser)) {
      emailList = emailList.filter(val =>
        !this.existUser.includes(val)
      );
    }

    if (Array.isArray(this.inviteUser)) {
      emailList = emailList.filter(val =>
        !this.inviteUser.includes(val)
      );
    }

    if (Array.isArray(this.inactiveUsers)) {
      emailList = emailList.filter(val =>
        !this.inactiveUsers.includes(val)
      );
    }
    
    if (Array.isArray(this.duplicateEmails)) {
      const seenEmails = new Set();

      emailList = emailList.filter(val => {
        const lowerCaseVal = val.toLowerCase();
        if (seenEmails.has(lowerCaseVal)) {
          return false;
        }
        seenEmails.add(lowerCaseVal);
        return true;
      });
    }

    console.log('emailList after filtering:', emailList);
    this.connectionRequest.reset();
    this.connectionRequest.patchValue({ email: emailList });
    this.modalService.hide(1);
  }



  referrallimit: any
  referalLimit() {
    this.util.startLoader()
    let data: any = {}
    data.userId = localStorage.getItem('userId');
    data.screenType = "in-app"
    this.api.create("home/findUserInvites", data).subscribe(
      (res: any) => {
        this.util.stopLoader();
        if (res.code === "00000" && this.connectionRequest.value.email.length > 0) {
          this.referalCountForAMonth = this.connectionRequest.value.email.length + res.data.referralCountOfTheMonth
          this.referrallimit = res.data.referralLimit;
          this.Alertmessage();
        }
      });
  }

  canShowRemark(status): boolean {
    return status === 'Bounce' ||
      status === 'Invalid' ||
      status === 'PENDING' ||
      status === 'DeliveryDelay';
  }

  canShowInviteMenu(data): boolean {
    return data?.status === 'PENDING' && data?.emailStatus !== 'Bounce';
  }

  canConnect(data): boolean {
    return data?.status === 'COMPLETED' && data?.inviteeUser?.connectionStatus === 'NOT_CONNECTED';
  }

  canCancelRequest(data): boolean {
    return data?.inviteeUser?.connectionStatus === 'REQUEST_SENT' &&
      data?.status !== 'CANCELLED' &&
      data?.status !== 'COMPLETED' &&
      data?.status !== 'USERCANCELLED';
  }

  canMessage(data): boolean {
    return data?.status === 'COMPLETED' && data?.inviteeUser?.connectionStatus === 'CONNECTED';
  }

  /** True when the Actions cell renders anything; drives the '-' placeholder. */
  hasActions(data): boolean {
    return data?.status === 'COMPLETED' || // the "5 Credits awarded" message always renders
      this.canShowInviteMenu(data) ||
      this.canConnect(data) ||
      this.canCancelRequest(data) ||
      this.canMessage(data);
  }

  getEmailStatusClass(emailStatus: string): EmailClassObject {
    switch (emailStatus) {
      case 'Bounce':
        return { status: 'Undelivered', class: 'cancelled-624' }; // red background
      case 'Invalid':
        return { status: 'Invalid', class: 'cancelled-624' }; // red background
      case 'PENDING':
        return { status: 'Pending', class: 'pending-413' }; // yellow background
      case 'Delivery':
        return { status: 'Delivered', class: 'completed-535' }; // green background
      case 'DeliveryDelay':
        return { status: 'Delivery Delayed', class: 'info-text897' }; // teal/info
      default:
        return { status: emailStatus, class: 'email-status-badge-123' }; // neutral badge
    }
  }

  getRemark(emailStatus: string): string {
    switch (emailStatus) {
      case 'Bounce':
        return 'This is an inactive email address.';
        // return 'Email bounced. Please check the email address.';
        //Please check the email address or try again.
      case 'Invalid':
        return 'Invalid email address.';
      case 'PENDING':
        return 'Email is queued for delivery yet to be sent.';
      case 'Delivery':
        return 'Email delivered successfully.';
      case 'DeliveryDelay':
        return 'Email is sent but is yet to be received by the receiver.';
      default:
        return 'No remarks available';
    }

  }

  resendInvitation(data) {
    this.util.startLoader()
    data.userId = localStorage.getItem('userId');
    data.inviteId = data.inviteId;

    this.api.create("home/InvitationActivationLink", data).subscribe(
      (res: any) => {
        this.util.stopLoader();

        switch (res.code) {
          case "00000":
            // Success - invitation sent
            Swal.fire({
              icon: "success",
              title: "Invitation Resent Successfully",
              text: "The user should have received another email invitation to sign up.",
              showDenyButton: false,
              showConfirmButton: true,
              allowOutsideClick: false
            });

            // Update canResend to false after successful send
            this.inviteRes.userInvites = this.inviteRes.userInvites.map((invite) =>
              invite.inviteId === data.inviteId ? { ...invite, canResend: false } : invite
            );
            break;

          case "U0010":
            // Invitation not found
            Swal.fire({
              icon: "error",
              title: "Invitation Not Found",
              text: "No invitation found for this email address.",
              showConfirmButton: true,
              allowOutsideClick: false
            });
            break;

          case "U0011":
            // Token still active - already sent
            Swal.fire({
              icon: "info",
              title: "Activation Link Already Sent",
              text: "An activation link has already been sent and is still valid.",
              showConfirmButton: true,
              allowOutsideClick: false
            });

            // Update canResend to false since link is still active
            this.inviteRes.userInvites = this.inviteRes.userInvites.map((invite) =>
              invite.inviteId === data.inviteId ? { ...invite, canResend: false } : invite
            );
            break;

          case "U0013":
            // Resend not allowed
            Swal.fire({
              icon: "warning",
              title: "Resend Not Allowed",
              text: "Resend is not allowed for this user as you have reached the allowed limit for the day.",
              showConfirmButton: true,
              allowOutsideClick: false
            });

            // Update canResend to false in UI to reflect backend state
            this.inviteRes.userInvites = this.inviteRes.userInvites.map((invite) =>
              invite.inviteId === data.inviteId ? { ...invite, canResend: false } : invite
            );
            break;

          case "INVALID_INPUT":
            // Invalid input
            Swal.fire({
              icon: "error",
              title: "Invalid Input",
              text: "Please provide a valid email address.",
              showConfirmButton: true,
              allowOutsideClick: false
            });
            break;

          case "99998":
            // Token generation failed
            Swal.fire({
              icon: "error",
              title: "Token Generation Failed",
              text: "Unable to generate activation token. Please try again later.",
              showConfirmButton: true,
              allowOutsideClick: false
            });
            break;

          case "99999":
            // Mail send failed or unexpected error
            Swal.fire({
              icon: "error",
              title: "Failed to Send",
              text: res.message || "Unable to send invitation. Please try again later.",
              showConfirmButton: true,
              allowOutsideClick: false
            });
            break;

          default:
            // Unknown error code
            Swal.fire({
              icon: "error",
              title: "Unexpected Error",
              text: res.message || "An unexpected error occurred. Please try again.",
              showConfirmButton: true,
              allowOutsideClick: false
            });
            break;
        }
      },
      (error) => {
        // Handle HTTP errors
        this.util.stopLoader();
        Swal.fire({
          icon: "error",
          title: "Network Error",
          text: "Unable to connect to server. Please check your connection and try again.",
          showConfirmButton: true,
          allowOutsideClick: false
        });
      }
    );
  }

  exceedErrorPopUp(count, referralLimit) {
    Swal.fire({
      icon: "error",
      title: +count + " of " + referralLimit + " invites available",
      showDenyButton: false,
      showConfirmButton: true,
      timer: 3000
    });
  }
  Alertmessage() {
    if ((this.connectionRequest.value.email != null && this.connectionRequest.value.email?.length > 0)
      && this.referalCountForAMonth > this.referrallimit) {
      const count = this.referrallimit - this.referalCountForAMonth
      if (this.referalCountForAMonth >= this.referrallimit) {
        this.util.stopLoader
        this.exceedErrorPopUp(0, this.referrallimit)
      } else if (this.referalCountForAMonth === 0) {
        this.exceedErrorPopUp(0, this.referrallimit)
      } else if (this.referalCountForAMonth < this.referrallimit && this.referalCountForAMonth > this.referrallimit) {

        this.util.stopLoader
        this.exceedErrorPopUp(count, this.referrallimit)
      }
      this.util.stopLoader()
      this.connectionRequest.controls['email'].setErrors({ invalid: true })
    } else {
      this.connectionRequest.controls['email'].setErrors(null);
      this.connectionRequest.controls['email'].updateValueAndValidity();
    }
  }

  referalCountForAMonth: number;
  datas: any
  loadAPIcall1: boolean = false;
  SendInvite(ValidEmail) {
    this.connectionRequest.markAllAsTouched();
    this.Alertmessage();
    if (this.connectionRequest.valid) {
      this.util.startLoader();
      if (this.userRes && this.userRes.firstName && this.userRes.lastName) {
        const input = {
          userId: this.userId,
          firstName: this.userRes.firstName,
          lastName: this.userRes.lastName,
          inviteEmailList: this.connectionRequest.value.email,
          message: this.connectionRequest.value.msg
        };

        this.api.create("home/inviteeUser", input).subscribe(
          (res) => {
            if (res.code === "00000") {
              // Success case
              this.handleSuccessResponse(res);
            } else if (res.code === "99998") {
              // Validation errors case
              this.handleValidationErrors(res, ValidEmail);
            } else {
              // Handle other error codes
              this.handleErrorResponse(res);
            }
          },
          (err) => {
            this.util.stopLoader();

          }
        );
      } else {
        this.util.stopLoader();
      }
    }
  }

  private handleValidationErrors(res: any, ValidEmail: any): void {
    // Initialize arrays with proper null checks and filter out empty values
    this.util.stopLoader();
    
    const existingUsers = res.data?.existingUsers;
    const alreadyInvited = res.data?.alreadyInvited;
    const duplicateEmails = res.data?.duplicateEmails;
    const inactiveUsers = res.data?.inactiveUsers;
    
    // Only assign arrays if they exist, are arrays, and have content
    this.existUser = (Array.isArray(existingUsers) && existingUsers.length > 0) ? existingUsers : [];
    this.inviteUser = (Array.isArray(alreadyInvited) && alreadyInvited.length > 0) ? alreadyInvited : [];
    this.duplicateEmails = (Array.isArray(duplicateEmails) && duplicateEmails.length > 0) ? duplicateEmails : [];
    this.inactiveUsers = (Array.isArray(inactiveUsers) && inactiveUsers.length > 0) ? inactiveUsers : [];

    // Only show modal if there are actual validation issues
    const hasValidationIssues = this.existUser.length > 0 ||
      this.inviteUser.length > 0 ||
      this.duplicateEmails.length > 0 ||
      this.inactiveUsers.length > 0;

    if (hasValidationIssues) {
      this.modalService.show(ValidEmail);
    } else {
      // No validation issues but got 99998 code - this might be an edge case
      Swal.fire({
        icon: "warning",
        title: "0 of 100 invites available",
        text: "",
        confirmButtonText : 'OK'
      });
    }
  }

  private handleSuccessResponse(res: any): void {
    setTimeout(() => {
      this.util.stopLoader();
      this.faqresponse = res.data;
      Swal.fire({
        icon: "success",
        title: "Invite sent successfully",
        showDenyButton: false,
        showConfirmButton: false,
        timer: 2000,
      });
      this.connectionRequest.reset();
      this.getinviteData();
    }, 500);
  }

  private handleErrorResponse(res: any): void {
    Swal.fire({
      icon: "error",
      title: "Failed to send invitation",
      text: res.message || "An unexpected error occurred",
      timer: 3000,
    });
    this.util.stopLoader();
  }

  private handleApiError(err: any): void {
    Swal.fire({
      icon: "error",
      title: "Network Error",
      text: "Please check your connection and try again",
      timer: 3000,
    });
  }

  private checkReferralLimits(): boolean {
    const emailList = this.connectionRequest.value.email;

    if (!emailList || emailList.length === 0) {
      return true; // No emails to validate
    }

    const remainingReferrals = this.referrallimit - this.referalCountForAMonth;

    if (this.referalCountForAMonth >= this.referrallimit) {
      // Already exceeded limit
      this.exceedErrorPopUp(0, this.referrallimit);
      this.setEmailControlError();
      return false;
    } else if (emailList.length > remainingReferrals) {
      // Would exceed limit with current request
      this.exceedErrorPopUp(remainingReferrals, this.referrallimit);
      this.setEmailControlError();
      return false;
    }

    // Clear any previous email errors
    this.clearEmailControlError();
    return true;
  }

  private setEmailControlError(): void {
    this.connectionRequest.controls['email'].setErrors({ referralLimitExceeded: true });
  }

  private clearEmailControlError(): void {
    this.connectionRequest.controls['email'].setErrors(null);
    this.connectionRequest.controls['email'].updateValueAndValidity();
  }
  getinviteuserLength(): number {
    return this.inviteUser?.length || 0;
  }

  getexistuserLength(): number {
    return this.existUser?.length || 0;
  }

  getDuplicateEmailsLength(): number {
    return this.duplicateEmails?.length || 0;
  }

  getInactiveUsersLength(): number {
    return this.inactiveUsers?.length || 0;
  }

  async showpopup(email:any){
    Swal.fire({
      icon: "warning",
      title: 'Are you sure?',
       text: 'Do you want to cancel this invitation?',
      showDenyButton: false,
      showCancelButton: true, 
      showConfirmButton: true,
      allowOutsideClick: false,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
           
    }).then((result)=>{
      if (result.isConfirmed){
        this.cancelInvite(email);
      }
    });
      
  }

  cancelInvite(email) {
    let data: any = {};
    data.userId = this.userId;
    data.screenType = 'in-app';
    data.inviteeEmail = email;
    this.util.startLoader();
    this.api.create("home/cancelInvite", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code == "00000") {
          Swal.fire({
            icon: "success",
            title: "Invite Cancelled Successfully",
            showDenyButton: false,
            showConfirmButton: false,

            timer: 2000,
          });
          // const invites = this.inviteRes.userInvites.filter(
          //   (invite) => invite.inviteeEmail === email
          // );
          // if (invites.length > 0) {
          //   invites.forEach((invite) => {
          //     invite.status = "CANCELLED";
          //   });
          // }
          this.inviteRes.userInvites = this.inviteRes.userInvites.map(invite => {
            if (invite.inviteeEmail === email) {
              return { ...invite, status: "CANCELLED" }; // create new object
            }
            return invite;
          });
          this.getinviteData();
        }
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  emailValid(control: AbstractControl) {
    var pattern: string =
      "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+){1,2}$";
    //if (Validators.email(new FormControl(control.value))) {
    const control1 = new UntypedFormControl(
      control.value,
      Validators.pattern(pattern)
    );
    if (control1.errors != null) {
      return {
        emailValid: true,
      };
    }
  }


  filterApi(val: string) {
    this.appliedFilter = val;
    if (this.params.status === val) {
      return; // Avoid duplicate API call if the same filter is already applied
    }
    this.params.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.params.status = val;
    // this.searchContent = "";
    this.stopScroll = false
    this.params.searchAfterKey = null
    this.selectedFilterName = val === "PENDING" ? "Pending Acceptance" :
      val === "CANCELLED" ? "Invitation Cancelled" : val === "COMPLETED" ? "Invite Accepted" :
        val === "USERCANCELLED" ? "User Cancelled" : val;
    this.inviteRes.userInvites = [];
    this.findUserInvitesApiCAll(this.params)
  }
  findUserInvitesApiCAll(data: any) {
    if (this.stopScroll) {
      return
    }
    this.inviteListLoading = true;
    this.api.create("home/findUserInvites", data).subscribe(
      (res: any) => {
        this.util.stopLoader();

        const newInvites = res.data.userInvites || [];
        const afterKey = res.data && res.data.searchAfterKey;
        const existingIds = new Set(this.inviteRes.userInvites.map(invite => invite.inviteId));

        newInvites.forEach((invite: any) => {
          if (!existingIds.has(invite.inviteId)) {
            this.inviteRes.userInvites.push(invite);
          }
        });
        if (
          JSON.stringify(this.prevAfterkey) === JSON.stringify(afterKey) ||
          newInvites.length === 0
        ) {
          this.stopScroll = true;
        }
        this.prevAfterkey = afterKey;
        this.inviteListLoading = false;
      },
      (error: any) => {
        this.util.stopLoader();
        this.inviteListLoading = false;
      }
    );
  }

  onScrollDown() {
    if (
      this.id == "2" &&
      JSON.stringify(this.params.searchAfterKey) !== JSON.stringify(this.prevAfterkey)
    ) {
      this.params.searchAfterKey =
        this.prevAfterkey && this.prevAfterkey.length === 0 ? null : this.prevAfterkey;
      this.findUserInvitesApiCAll(this.params);

    }
  }

  searchContent: string = "";
  onSearch() {
    this.params.status = this.appliedFilter;
    this.params.searchAfterKey = null
    this.stopScroll = false;
    this.params.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.util.startLoader();
    this.inviteRes.userInvites = [];
    this.findUserInvitesApiCAll(this.params)
  }
}


